/*
 * "הלוק המושלם בקליק אחד" cross-sell strip - behaviour only.
 *
 * The tiles, the variant pickers, the prices and every pop-up's gallery,
 * description and variants are rendered by snippets/bundle-offering.liquid and
 * snippets/bundle-offering-card.liquid. Nothing is fetched to build the strip:
 * the original ran up to five Storefront GraphQL queries before it could show
 * anything, and one more every time a tile was opened.
 *
 * What is left is the interactive part: which variants are ticked, what the
 * total says, and posting the selection to the cart.
 *
 * Ported from the Variant experience exp-EXPCB2DD8BB, variation 2.
 */
(function () {
  'use strict';

  var EXPERIMENT_ID = 'EXPCB2DD8BB';
  var VARIATION_ID = '2';

  var CURRENCY_SYMBOLS = { ILS: '₪', USD: '$', EUR: '€', GBP: '£' };
  var REMOVE_ANIMATION_MS = 300;
  var SWIPE_THRESHOLD_PX = 40;

  function track(eventName, payload) {
    try {
      if (typeof Variant === 'undefined' || !Variant.publishCustomEvent) return;
      var data = { experiment_id: EXPERIMENT_ID, variation_id: VARIATION_ID };
      for (var key in payload) {
        if (Object.prototype.hasOwnProperty.call(payload, key)) data[key] = payload[key];
      }
      Variant.publishCustomEvent(eventName, data);
    } catch (e) {
      /* never let telemetry break the experience */
    }
  }

  /**
   * Amounts travel as integer minor units, so a total never drifts the way a
   * float sum of prices does. The symbol stays to the left of the number,
   * which is what the shop's design calls for.
   */
  function formatMoney(cents) {
    var code = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'ILS';
    var symbol = CURRENCY_SYMBOLS[code];
    var amount = cents / 100;
    var number;

    try {
      number = new Intl.NumberFormat(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(amount);
    } catch (e) {
      number = amount.toFixed(2);
    }

    return symbol ? symbol + number : number + ' ' + code;
  }

  /* -----------------------------------------------------------------------
   * Cart
   * --------------------------------------------------------------------- */
  function sectionIds() {
    return ['cart-drawer', 'header', 'cart-icon']
      .map(function (name) {
        var element = document.querySelector('.shopify-section[id*="' + name + '"]');
        return element ? element.id.replace('shopify-section-', '') : null;
      })
      .filter(function (id, index, all) {
        return id && all.indexOf(id) === index;
      })
      .join(',');
  }

  function renderSections(sections) {
    Object.keys(sections).forEach(function (id) {
      var html = sections[id];
      if (html == null) return;
      var element = document.getElementById('shopify-section-' + id);
      if (!element) return;
      element.outerHTML = html;
      document.dispatchEvent(new CustomEvent('shopify:section:load', { detail: { sectionId: id } }));
    });
  }

  function openCartDrawer() {
    var drawer = document.querySelector('cart-drawer, #cart-drawer, [data-drawer="cart"]');
    if (!drawer) return;
    requestAnimationFrame(function () {
      drawer.setAttribute('open', '');
      drawer.classList.add('is-open', 'active');
    });
  }

  /** Posts lines to the cart and swaps in the sections the response carries. */
  function addToCart(lines) {
    var rootUrl = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var sections = sectionIds();
    var body = { items: lines };

    if (sections) {
      body.sections = sections;
      body.sections_url = window.location.pathname;
    }

    return fetch(rootUrl + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (response) {
        return response.json().then(function (json) {
          if (!response.ok || json.status) throw new Error(json.description || 'add failed');
          return json;
        });
      })
      .then(function (json) {
        if (json.sections) renderSections(json.sections);
        return json;
      });
  }

  /**
   * Shuts every variant dropdown but one. Kept out of init() so the listener
   * that closes them on an outside click is registered once, not once per
   * render of the product section.
   */
  function closeMenus(except) {
    Array.prototype.slice
      .call(document.querySelectorAll('[data-bundle-offering-select-menu]'))
      .forEach(function (menu) {
        if (menu === except || menu.hidden) return;
        menu.hidden = true;
        var toggle = menu.parentNode.querySelector('[data-bundle-offering-select-toggle]');
        if (toggle) toggle.setAttribute('aria-expanded', 'false');
      });
  }

  document.addEventListener('click', function (event) {
    // Ticking a box inside an open menu must not close it.
    if (event.target.closest('[data-bundle-offering-select]')) return;
    closeMenus(null);
  });

  /* -----------------------------------------------------------------------
   * The strip
   * --------------------------------------------------------------------- */
  function init(root) {
    if (root.dataset.bundleOfferingReady) return;
    root.dataset.bundleOfferingReady = '1';

    var strip = root.querySelector('[data-bundle-offering-track]');
    var totalElement = root.querySelector('[data-bundle-offering-total]');
    var countElement = root.querySelector('[data-bundle-offering-count]');
    var submitButton = root.querySelector('[data-bundle-offering-submit]');
    if (!strip || !submitButton) return;

    // ---------------------------------------------------------------------
    // Reading the current selection straight off the DOM
    // ---------------------------------------------------------------------
    function cards() {
      return Array.prototype.slice.call(strip.querySelectorAll('[data-bundle-offering-card]'));
    }

    /**
     * The variants a tile contributes: its single hidden one, or every box
     * the shopper has left ticked.
     */
    function chosenInputs(card) {
      var fixed = card.querySelector('input[type="hidden"][data-bundle-offering-variant]');
      if (fixed) return [fixed];
      return Array.prototype.slice.call(
        card.querySelectorAll('input[type="checkbox"][data-bundle-offering-variant]:checked')
      );
    }

    function priceOf(input) {
      return parseInt(input.getAttribute('data-price'), 10) || 0;
    }

    function cardTotal(card) {
      return chosenInputs(card).reduce(function (sum, input) {
        return sum + priceOf(input);
      }, 0);
    }

    // ---------------------------------------------------------------------
    // Keeping the tile and the summary honest
    // ---------------------------------------------------------------------
    function refreshCard(card) {
      // A tile with nothing purchasable on it (a sold-out product being
      // viewed) keeps the price Liquid rendered.
      if (!card.querySelector('[data-bundle-offering-variant]')) return;

      var chosen = chosenInputs(card);
      var priceElement = card.querySelector('[data-bundle-offering-price]');

      if (priceElement) {
        // Several variants of the same product: the count explains the price.
        priceElement.textContent =
          chosen.length > 1
            ? formatMoney(cardTotal(card)) + ' (' + chosen.length + ')'
            : formatMoney(cardTotal(card));
      }

      var label = card.querySelector('[data-bundle-offering-select-label]');
      if (label) {
        label.textContent =
          chosen.length > 1
            ? chosen.length + ' נבחרו'
            : (chosen[0] && chosen[0].getAttribute('data-value')) || 'בחר';
      }
    }

    function refreshSummary() {
      var total = 0;
      var items = 0;

      cards().forEach(function (card) {
        chosenInputs(card).forEach(function (input) {
          total += priceOf(input);
          items++;
        });
      });

      if (totalElement) totalElement.textContent = formatMoney(total);
      if (countElement) {
        countElement.hidden = items <= 1;
        countElement.textContent = items + ' פריטים';
      }

      submitButton.disabled = items === 0;
    }

    // ---------------------------------------------------------------------
    // Selection
    // ---------------------------------------------------------------------
    strip.addEventListener('change', function (event) {
      var checkbox = event.target.closest('input[type="checkbox"][data-bundle-offering-variant]');
      if (!checkbox) return;

      var card = checkbox.closest('[data-bundle-offering-card]');
      if (!card) return;

      // A tile always offers something: the last ticked box cannot be cleared.
      if (!checkbox.checked && chosenInputs(card).length === 0) {
        checkbox.checked = true;
        return;
      }

      refreshCard(card);
      refreshSummary();
    });

    // ---------------------------------------------------------------------
    // The dropdown a tile uses when its product has more than three variants,
    // and removing a tile
    // ---------------------------------------------------------------------
    strip.addEventListener('click', function (event) {
      var toggle = event.target.closest('[data-bundle-offering-select-toggle]');
      if (toggle) {
        var menu = toggle.parentNode.querySelector('[data-bundle-offering-select-menu]');
        if (!menu) return;
        var willOpen = menu.hidden;
        closeMenus(menu);
        menu.hidden = !willOpen;
        toggle.setAttribute('aria-expanded', String(willOpen));
        return;
      }

      var removeButton = event.target.closest('[data-bundle-offering-remove]');
      if (!removeButton) return;

      var card = removeButton.closest('[data-bundle-offering-card]');
      if (!card) return;

      card.classList.add('is-removing');
      setTimeout(function () {
        if (card.parentNode) card.parentNode.removeChild(card);
        refreshSummary();
      }, REMOVE_ANIMATION_MS);
    });

    // ---------------------------------------------------------------------
    // Adding the strip to the cart
    // ---------------------------------------------------------------------
    submitButton.addEventListener('click', function () {
      var lines = [];
      var productCount = 0;
      var total = 0;

      cards().forEach(function (card) {
        var chosen = chosenInputs(card);
        if (chosen.length) productCount++;

        chosen.forEach(function (input) {
          var id = parseInt(input.getAttribute('data-bundle-offering-variant'), 10);
          if (!id) return;
          lines.push({ id: id, quantity: 1 });
          total += priceOf(input);
        });
      });
      if (!lines.length) return;

      submitButton.disabled = true;
      submitButton.textContent = 'מוסיף לעגלה...';

      addToCart(lines)
        .then(function () {
          submitButton.textContent = '✓ נוסף לעגלה!';
          track('bundle_add_to_cart', {
            product_count: productCount,
            line_count: lines.length,
            total_value: total / 100
          });

          setTimeout(function () {
            openCartDrawer();
            submitButton.disabled = false;
            submitButton.textContent = 'הוספה לסל';
            refreshSummary();
          }, 400);
        })
        .catch(function () {
          submitButton.textContent = 'שגיאה - נסה שוב';
          setTimeout(function () {
            submitButton.disabled = false;
            submitButton.textContent = 'הוספה לסל';
            refreshSummary();
          }, 3000);
        });
    });

    cards().forEach(refreshCard);
    refreshSummary();
    adoptPopup();
  }

  /* -----------------------------------------------------------------------
   * The tile pop-up.
   *
   * One dialog serves every tile and is filled from that tile's own
   * <template> - the gallery, the description and the variants are already in
   * the page, so opening one costs no request and cannot fail the way the
   * original's product query could (it gave up and navigated away when it
   * did).
   * --------------------------------------------------------------------- */
  var slideIndex = 0;
  var slideCount = 0;
  var scrollLocked = false;

  /**
   * Moves the rendered dialog onto <body>, where no ancestor can become the
   * containing block of a fixed-position element, and drops any copy left
   * behind by an earlier render of the product section.
   */
  function adoptPopup() {
    var popups = Array.prototype.slice.call(
      document.querySelectorAll('[data-bundle-offering-popup-root]')
    );
    var popup = popups.shift();
    if (!popup) return;

    popups.forEach(function (stale) {
      if (stale.parentNode) stale.parentNode.removeChild(stale);
    });

    if (popup.parentNode !== document.body) document.body.appendChild(popup);
  }

  function popupRoot() {
    return document.querySelector('[data-bundle-offering-popup-root]');
  }

  function lockScroll() {
    if (scrollLocked) return;
    scrollLocked = true;
    var scrollbar = window.innerWidth - document.documentElement.clientWidth;
    document.body.style.overflow = 'hidden';
    if (scrollbar > 0) document.body.style.paddingRight = scrollbar + 'px';
  }

  function unlockScroll() {
    if (!scrollLocked) return;
    scrollLocked = false;
    document.body.style.overflow = '';
    document.body.style.paddingRight = '';
  }

  function openPopup(card) {
    var popup = popupRoot();
    var dialog = popup && popup.querySelector('[data-bundle-offering-popup-dialog]');
    var template = card.querySelector('template[data-bundle-offering-popup]');
    if (!popup || !dialog || !template) return;

    dialog.replaceChildren(template.content.cloneNode(true));
    dialog.scrollTop = 0;
    popup.classList.add('is-open');
    popup.setAttribute('aria-hidden', 'false');
    lockScroll();

    slideIndex = 0;
    slideCount = dialog.querySelectorAll('.bundle-offering__slide').length;

    track('bundle_product_viewed', {
      product_handle: card.getAttribute('data-handle') || '',
      product_title: card.getAttribute('data-title') || ''
    });
  }

  function closePopup() {
    var popup = popupRoot();
    if (!popup || !popup.classList.contains('is-open')) return;
    popup.classList.remove('is-open');
    popup.setAttribute('aria-hidden', 'true');
    unlockScroll();
  }

  function goToSlide(index) {
    if (index < 0 || index >= slideCount) return;
    slideIndex = index;

    var popup = popupRoot();
    if (!popup) return;

    var galleryTrack = popup.querySelector('[data-bundle-offering-gallery-track]');
    // The track is laid out right to left, so a positive shift advances it.
    if (galleryTrack) galleryTrack.style.transform = 'translateX(' + index * 100 + '%)';

    Array.prototype.slice
      .call(popup.querySelectorAll('[data-bundle-offering-dot]'))
      .forEach(function (dot, dotIndex) {
        dot.classList.toggle('is-active', dotIndex === index);
      });
  }

  function addFromPopup(button) {
    var id = parseInt(button.getAttribute('data-variant-id'), 10);
    if (!id) return;

    button.disabled = true;
    button.textContent = 'מוסיף...';

    addToCart([{ id: id, quantity: 1 }])
      .then(function () {
        button.textContent = '✓ נוסף לסל!';
        track('bundle_product_add_to_cart', { variant_id: String(id) });

        setTimeout(function () {
          closePopup();
          setTimeout(openCartDrawer, 300);
        }, 800);
      })
      .catch(function () {
        button.textContent = 'שגיאה - נסה שוב';
        button.disabled = false;
        setTimeout(function () {
          button.textContent = 'הוספה לסל';
        }, 2000);
      });
  }

  document.addEventListener('click', function (event) {
    // Opening: the image or the name of any tile but the shopper's own.
    var opener = event.target.closest('[data-bundle-offering-open]');
    if (opener) {
      var card = opener.closest('[data-bundle-offering-card]');
      if (card && !card.hasAttribute('data-bundle-offering-current')) {
        event.preventDefault();
        openPopup(card);
      }
      return;
    }

    var popup = popupRoot();
    if (!popup || !popup.classList.contains('is-open')) return;

    if (event.target === popup || event.target.closest('[data-bundle-offering-popup-close]')) {
      closePopup();
      return;
    }

    var dot = event.target.closest('[data-bundle-offering-dot]');
    if (dot) {
      goToSlide(parseInt(dot.getAttribute('data-bundle-offering-dot'), 10) || 0);
      return;
    }

    var descToggle = event.target.closest('[data-bundle-offering-desc-toggle]');
    if (descToggle) {
      var desc = popup.querySelector('[data-bundle-offering-desc]');
      if (!desc) return;
      var expanded = desc.classList.toggle('is-expanded');
      var fade = popup.querySelector('[data-bundle-offering-desc-fade]');
      if (fade) fade.hidden = expanded;
      descToggle.textContent = expanded ? 'הצג פחות' : 'קרא עוד';
      return;
    }

    var variantButton = event.target.closest('[data-bundle-offering-popup-variant]');
    if (variantButton) {
      Array.prototype.slice
        .call(popup.querySelectorAll('[data-bundle-offering-popup-variant]'))
        .forEach(function (button) {
          var isChosen = button === variantButton;
          button.classList.toggle('is-selected', isChosen);
          button.setAttribute('aria-pressed', String(isChosen));
        });

      var priceElement = popup.querySelector('[data-bundle-offering-popup-price]');
      if (priceElement) {
        priceElement.textContent = formatMoney(
          parseInt(variantButton.getAttribute('data-price'), 10) || 0
        );
      }

      var addButton = popup.querySelector('[data-bundle-offering-popup-atc]');
      if (addButton) {
        addButton.setAttribute(
          'data-variant-id',
          variantButton.getAttribute('data-bundle-offering-popup-variant')
        );
      }
      return;
    }

    var atc = event.target.closest('[data-bundle-offering-popup-atc]');
    if (atc) addFromPopup(atc);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closePopup();
  });

  // Swiping the gallery.
  var touchStartX = 0;

  document.addEventListener(
    'touchstart',
    function (event) {
      if (!event.target.closest('[data-bundle-offering-gallery]')) return;
      touchStartX = event.changedTouches[0].screenX;
    },
    { passive: true }
  );

  document.addEventListener(
    'touchend',
    function (event) {
      if (!event.target.closest('[data-bundle-offering-gallery]')) return;
      var distance = touchStartX - event.changedTouches[0].screenX;
      if (Math.abs(distance) <= SWIPE_THRESHOLD_PX) return;
      goToSlide(distance > 0 ? slideIndex - 1 : slideIndex + 1);
    },
    { passive: true }
  );

  function boot() {
    var root = document.querySelector('[data-bundle-offering]');
    if (root) init(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // The product section re-renders on variant change; re-run then.
  document.addEventListener('shopify:section:load', boot);
})();
